import React, { useEffect } from 'react'
import slidesOne from "../../img/slidesOne.png";
import slidesTwo from "../../img/SlidesTwo.png";
import slidesTree from "../../img/slidesTree.png";
import slidesFour from "../../img/slidesFour.png";
import institucional from "../../img/institucional.jpg";
import seguros from "../../img/seguros.jpg";
import normativa from "../../img/normativa.jpg";
import descargas from "../../img/descargas.png";
import contacto from "../../img/contacto.jpg";
import blog from "../../img/blog.webp";
import consultasReclamos from "../../img/consultasReclamos.jpg";
import compromiso from "../../img/compromiso.jpg";
import atencionCliente from "../../img/atencionCliente.jpg";
import accidente from "../../img/accidente.jpg";
import faq from "../../img/faq.webp";
import rrhh from "../../img/rrhh.jpg";
import prevencion from "../../img/prevencion.webp";
import macroLatitud from "../../img/macroLatitud.webp";
import modalDenunciasDeAccidenteLaboralART from "../../img/modalDenunciasDeAccidenteLaboralART.webp";
import credencialDigital from "../../img/credencialDigital.webp";
import capacitacion from "../../img/capacitacion.png";
import cuestionario from "../../img/cuestionario.jpg"
import pagoPoliza from "../../img/pagoPoliza.webp"
import "../../css/slides.css";

import { Link } from 'react-router-dom';

const Slides = ({M,tipoSlides,setModalClientes}) => {
   useEffect(() => {
      let elems = document.querySelectorAll(".slider");
      M.Slider.init(elems, {
         indicators: false,
         height: 525,
         duration: 1000,
         interval: 4000,
      });
      let modal = document.querySelectorAll(".modal-clientes");
      M.Modal.init(modal);
   }, []);
   return (
      <>
         <div className="section animated fadeIn">
            <div className="row">
               <div className="col s12">
                  <div className="slider">
                     <ul className="slides">
                        {tipoSlides === 'home' &&
                           <>
                              <li>
                                 <img src={slidesOne} alt="" className="responsive-img"/>
                              </li>
                              <li>
                                 <img src={slidesTwo} alt=""/>
                                 <div className="trasnparent-slides col s12">
                                    <div className="caption center-align">
                                       <h4>Asistencia personalizada<br/>Conozca Nuestros Productos</h4>
                                       <Link className="waves-effect waves-light btn light-blue accent-3" to={"/seguros"}>Leer más</Link>
                                       <br/>
                                       <br/>
                                    </div>
                                 </div>
                              </li>
                              <li>
                                 <img src={slidesTree} alt="" className="responsive-img"/>
                                 <div className="trasnparent-slides col s12">
                                    <div className="caption center-align">
                                       <h4>Presentes en Jujuy y Salta</h4>
                                       <h5 className="light">¿Por qué elegirnos?</h5>
                                       <Link className="waves-effect waves-light btn light-blue accent-3" to={"/compromiso"}>Leer más</Link>
                                       <br/>
                                       <br/>
                                    </div>
                                 </div>
                              </li>    
                              <li>
                                 <img src={slidesFour} alt="" className="responsive-img"/>
                                 <div className="trasnparent-slides col s12">
                                    <div className="caption center-align">
                                       <h4>Clientes que confían en Nosotros</h4>
                                       {/* <Link onClick={(e)=>setModalClientes('modal-show')}>ver</Link> */}
                                       <Link className="waves-effect waves-light btn light-blue accent-3" onClick={(e)=>setModalClientes('modal-show')}>Clientes</Link>
                                       <br/>
                                       <br/>
                                       <br/>
                                    </div>
                                 </div>
                              </li>  
                           </>
                        }
                        {tipoSlides === 'institucional' &&
                           <li>
                              <img src={institucional} alt="" className="responsive-img"/>
                              <div className="trasnparent-slides col s12 m12 l12 x12">
                                 <div className="caption center-align">
                                    <h4 className="uppercase">Institucional</h4>
                                    <br/>
                                 </div>
                              </div>
                           </li>
                        }
                        {tipoSlides === 'seguros' &&
                           <li>
                              <img src={seguros} alt="" className="responsive-img"/>
                              <div className="trasnparent-slides col s12 m12 l12 x12">
                                    <div className="caption center-align">
                                       <h4 className="uppercase">Seguros</h4>
                                       <br/>
                                    </div>
                              </div>
                           </li>
                        }
                        {tipoSlides === 'normativa' &&
                           <li>
                              <img src={normativa} alt="" className="responsive-img"/>
                              <div className="trasnparent-slides col s12 m12 l12 x12">
                                    <div className="caption center-align">
                                       <h4 className="uppercase">Normativa</h4>
                                       <br/>
                                    </div>
                              </div>
                           </li>
                        }
                        {tipoSlides === 'descargas' &&
                           <li>
                              <img src={descargas} alt="" className="responsive-img"/>
                              <div className="trasnparent-slides col s12 m12 l12 x12">
                                    <div className="caption center-align">
                                       <h4 className="uppercase">descargas</h4>
                                       <br/>
                                    </div>
                              </div>
                           </li>
                        }
                        {tipoSlides === 'contacto' &&
                           <li>
                              <img src={contacto} alt="" className="responsive-img"/>
                              <div className="trasnparent-slides col s12 m12 l12 x12">
                                 <div className="caption center-align">
                                    <h4 className="uppercase">contactenos</h4>
                                    <br/>
                                 </div>
                              </div>
                           </li>
                        }
                        {tipoSlides === 'blog' &&
                           <li>
                              <img src={blog} alt="" className="responsive-img"/>
                              <div className="trasnparent-slides col s12 m12 l12 x12">
                                 <div className="caption center-align">
                                    <h4 className="uppercase">blog</h4>
                                    <br/>
                                 </div>
                              </div>
                           </li>
                        }
                        {tipoSlides === 'consultasReclamos' &&
                           <li>
                              <img src={consultasReclamos} alt="" className="responsive-img"/>
                              <div className="trasnparent-slides col s12 m12 l12 x12">
                                    <div className="caption center-align">
                                       <h4 className="uppercase">consultas y reclamos</h4>
                                       <br/>
                                    </div>
                              </div>
                           </li>
                        }
                        {tipoSlides === 'compromiso' &&
                           <li>
                              <img src={compromiso} alt="" className="responsive-img"/>
                              <div className="trasnparent-slides col s12 m12 l12 x12">
                                 <div className="caption center-align">
                                    <h4 className="uppercase">Compromiso</h4>
                                    <br/>
                                 </div>modalDenunciasDeAccidenteLaboralART
                              </div>
                           </li>
                        }
                        {tipoSlides === "serviciodetencion" &&
                           <li>
                              <img src={atencionCliente} alt="" className="responsive-img"/>
                              <div className="trasnparent-slides col s12 m12 l12 x12">
                                    <div className="caption center-align">
                                       <h4 className="uppercase">Servicio de atención</h4>
                                       <br/>
                                    </div>
                              </div>
                           </li>
                        }
                        {tipoSlides === "accidente" &&
                           <li>
                              <img src={accidente} alt="" className="responsive-img"/>
                              <div className="trasnparent-slides col s12 m12 l12 x12">
                                 <div className="caption center-align">
                                    <h4 className="uppercase">¿Cómo actuar en caso de accidente?</h4>
                                    <br/>
                                 </div>
                              </div>
                           </li>
                        }
                        {tipoSlides === "faq" &&
                           <li>
                              <img src={faq} alt="" className="responsive-img"/>
                              <div className="trasnparent-slides col s12 m12 l12 x12">
                                    <div className="caption center-align">
                                       <h4 className="uppercase">Preguntas Frecuentes</h4>
                                       <br/>
                                    </div>
                              </div>
                           </li>
                        }
                        {tipoSlides === "rrhh" &&
                           <li>
                              <img src={rrhh} alt="" className="responsive-img"/>
                              <div className="trasnparent-slides col s12 m12 l12 x12">
                                    <div className="caption center-align">
                                       <h4 className="uppercase">recursos humanos</h4>
                                       <br/>
                                    </div>
                              </div>
                           </li>
                        }
                        {tipoSlides === "modalHome" &&
                        <>
                           <li>
                              <a href="pagoPoliza"><img src={macroLatitud} alt="" className="responsive-img"/></a>
                           </li>
                           <li>
                              <img src={modalDenunciasDeAccidenteLaboralART} alt="" className="responsive-img"/>
                           </li>
                           <li>
                              <img src={credencialDigital} alt="" className="responsive-img"/>
                           </li>
                        </>
                        }
                        {tipoSlides === "prevencion" &&
                           <li>
                              <img src={prevencion} alt="" className="responsive-img"/>
                              <div className="trasnparent-slides col s12 m12 l12 x12">
                                 <div className="caption center-align">
                                    <h4 className="uppercase">prevención</h4>
                                    <br/>
                                 </div>
                              </div>
                           </li>
                        }
                        {tipoSlides === "capacitacion" &&
                           <li>
                              <img src={capacitacion} alt="" className="responsive-img"/>
                              <div className="trasnparent-slides col s12 m12 l12 x12">
                                 <div className="caption center-align">
                                    <h4 className="uppercase">capacitación</h4>
                                    <br/>
                                 </div>
                              </div>
                           </li>
                        }
                        {tipoSlides === "cuestionario" &&
                           <li>
                              <img src={cuestionario} alt="" className="responsive-img"/>
                              <div className="trasnparent-slides col s12 m12 l12 x12">
                                 <div className="caption center-align">
                                    <h4 className="uppercase">cuestionario</h4>
                                    <br/>
                                 </div>
                              </div>
                           </li>
                        }
                        {tipoSlides === "pagoPoliza" &&
                           <li>
                              <img src={pagoPoliza} alt="" className="responsive-img"/>
                              <div className="trasnparent-slides col s12 m12 l12 x12">
                                 <div className="caption center-align">
                                    <h4 className="uppercase">PAGÁ TU PÓLIZA DE UNA FORMA SENCILLA</h4>
                                    <br/>
                                 </div>
                              </div>
                           </li>
                        }
                     </ul>
                  </div>
               </div>
            </div>
            <div id="seccionPrestadores"/> 
         </div>
      </>
   )
}

export default Slides